import React, {Component} from 'react';
import {withRouter} from 'react-router-dom';
import Svg from '../helpers/svg';
import PageHeader from '../helpers/pageHeader';
import fpRest from '../helpers/fpRest';
import CsvImporter from '../helpers/csvImporter';
import settingsHeaderNav from '../helpers/settingsHeaderNav';
import Cards from '../helpers/cards';
import Loader from 'react-loader-advanced';
import Alert from 'react-s-alert';
import 'react-s-alert/dist/s-alert-default.css';
import 'react-s-alert/dist/s-alert-css-effects/slide.css';
import 'react-table/react-table.css';

class AssetSettingsRoute extends Component {
    constructor(props) {
        super(props)

        this.state = {
            showLoader: true,
            assetTypes: [],
            isImporterOpen: false,
            hideInactive: true,
            isNewDropdownOpen: false,
            isImportDropdownOpen: false,
            shouldCreateAssetType: false,
        };
    };

    getData = async () => {
        if (this.state.showLoader === false) this.setState({showLoader: true});
        try {
            const res = await fpRest.get('assets/types');
            const assetTypes = res.data;
            console.log(assetTypes)
            this.setState({assetTypes, showLoader: false});
        }
        catch (err) {
            console.log(err);
        };          
    };

    startImport = () => {
        this.setState({isImporterOpen: true});
    };

    closeImporter = () => {
        this.setState({isImporterOpen: false});
    };

    toggleImportDropdown = () => {
        this.setState({isImportDropdownOpen:!this.state.isImportDropdownOpen});
    };
    
    toggleNewDropdown = () => {
        this.setState({isImportDropdownOpen:!this.state.isNewDropdownOpen});
    };

    toggleInactive = () => {
        this.setState({hideInactive: !this.state.hideInactive});
    };

    createAssetType = () => {
        this.setState({shouldCreateAssetType: true}, () => {
            this.setState({shouldCreateAssetType: false});
        });
    }   

    saveAssetType = (all, item, type, dest, action) => {
        this.setState({assetTypes: all[0].assetTypes, showLoader: true});
        console.log(type, action);
        if (action === 'create') {
            fpRest.post(`assets/types`, type)
            .then(res => {
                this.getData();
            })
            .catch(err => {
                console.log(err);
                this.getData();
            });  
        }
        else if (action === 'update') {
            fpRest.patch(`assets/types/${type.id}`, type)
            .then(res => {
                this.getData();
            })
            .catch(err => {
                console.log(err);
                this.getData();
            });  
        }
    };   

    componentDidMount() {
        this.getData();        
    }

    render() {
        const {toggleImportDropdown, toggleNewDropdown, startImport, closeImporter, toggleInactive, saveAssetType, createAssetType} = this;
        const {showLoader, assetTypes, maintenanceItems, hideInactive, isImporterOpen, isImportDropdownOpen, isNewDropdownOpen, shouldCreateAssetType, shouldCreateMaintenanceItem} = this.state;

        return (
            <Loader show={showLoader} message={<Svg use="loader"/>} disableDefaultStyles={true}>
                <PageHeader
                    navItems={settingsHeaderNav('assetTypes')}
                    actionItems={[
                        //{label: <Svg use="add" />, tip: 'New Asset Type', action: createAssetType},
                        //{label: <Svg use="upload" />, tip: 'Upload Policies', options: [{label: 'Select CSV File', action: startImport}, {label: `${<Svg use="add" />} New Asset Type`, action: createAssetType},], isOpen: isNewDropdownOpen, action: toggleNewDropdown},
                    ]} 
                />
                <Cards
                    items={[{name: 'Asset Types', assetTypes}]}
                    mappings={{
                        header: {
                            accessor: 'name',
                            tag:'h2'
                        },
                        subItems: {
                            accessor: 'assetTypes',
                            newItemText: 'New Asset Type',
                            header: {
                                accessor: 'name',
                                tag: 'h3'
                            }
                        }
                    }}
                    areItemsEditable = {false}
                    createNewItem = {shouldCreateAssetType}
                    onSave={saveAssetType}
                />           
                <Alert stack={{limit: 3}} effect="slide" html={true} />
            </Loader>
        );
    };
}

export default withRouter(AssetSettingsRoute);